import { clsx } from 'clsx';
import _ from 'lodash';
import { PropTypes } from 'prop-types';

import HeroBoxHeaderTitle from '../HeroBoxHeaderTitle/HeroBoxHeaderTitle';

function HeroBoxHeader(props) {
  const { titles = [], icon = { isSVG: false, headerIcon: undefined } } = props;
  const { isSVG, headerIcon } = icon;

  return (
    <div className="hero-box__header">
      <div>
        <i
          className={clsx({
            'svg-icon': isSVG,
            [`fa ${headerIcon}`]: !isSVG,
          })}
        >
          {isSVG && headerIcon(49, 49)}
        </i>
      </div>

      {titles.map((title) => (
        // TODO: make it consistent across application
        <HeroBoxHeaderTitle key={_.uniqueId()} {...title} />
      ))}
    </div>
  );
}

HeroBoxHeader.propTypes = {
  titles: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      subTitle: PropTypes.string,
    }),
  ),
  icon: PropTypes.shape({
    isSVG: PropTypes.bool,
    headerIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  }),
};

export default HeroBoxHeader;
